import Humanize from 'humanize-plus';
import { replaceAll } from './replaceAll';

export const humanize = (str?: string) => {
  if (str == null) {
    return null;
  }

  return Humanize.titleCase(replaceAll(str.toLowerCase(), '_', ' '));
};

export const humanizeCamelCase = (str?: string) => {
  if (str == null) {
    return null;
  }

  const spaced = str.replace(/([A-Z])/g, ' $1');
  return Humanize.titleCase(spaced.trim());
};
